export const BUILD_ALPHA = 3;
export const BUILD_BETA = 2;
export const BUILD_RELEASE_READY = 1;
export const BUILD_RELEASE_OFFICIAL = 0;
export const BUILD_SERVICE_PACK = 4;
